 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-09764ebc":"6c9ac3cc","chunk-0b3b1f24":"452cb15f","chunk-0c583984":"c81f3958","chunk-4a5f46a6":"c92ebc7b","chunk-204db84c":"56b0adc8","chunk-8f05731e":"a1f29870","chunk-f7bef87a":"0f5d296c","chunk-34294a1e":"4a0fca5c","chunk-2e40015c":"0c7dcff6","chunk-aa53906a":"41ef3619","chunk-540f1b15":"0b66f807","chunk-05d1e21f":"ff1c4e0e","chunk-6eb2e206":"2ebd637b","chunk-27fe0cec":"9256fc83","chunk-513ece05":"a8148ed6","chunk-728769ff":"f8f1cc82","chunk-20b6fa76":"584ded8a","chunk-a0b7269c":"fc2d127b","chunk-0e4885da":"0f3373c5","chunk-18694b29":"0f1ca81e","chunk-276956d6":"6b34065a","chunk-fbe6f382":"d88ad4db","chunk-032dd8e3":"d0ec8a18","chunk-7104e44b":"8ca9af64","chunk-07e25c8c":"f57b9d1f","chunk-644c32b6":"58a16609","chunk-d58206c6":"4fa51528","chunk-6ac93044":"e546f94a","chunk-76751786":"fc4add9d","chunk-bcdaca1a":"5495d2ad","chunk-ef04401a":"f104361a","chunk-c300fdae":"4dacdfc4","chunk-849c1726":"4981ac3b","chunk-0318066b":"36860578","chunk-0949322a":"94478b53","chunk-cfc1f3be":"02a80d9b","chunk-2d0bac5f":"426372af","chunk-2d0c11d7":"51fe31e6","chunk-dcdb2db4":"7d247095","chunk-0c8f709c":"33f9a296","chunk-25e6c56f":"05b8df12","chunk-ee2269fe":"dbd57a17","chunk-0cffc490":"f895c00f","chunk-10ab300e":"3970eb20","chunk-13966a58":"9903cbe4","chunk-18a6dbbc":"287323b7","chunk-1e7c1501":"4597039d","chunk-22aeb9fe":"e51fb359","chunk-2d0a3981":"20193db2","chunk-2d0a463c":"e074e68f","chunk-2d0ac931":"1221fdd9","chunk-2d0ac942":"36e15c21","chunk-2d0b2b2b":"56c7ef2d","chunk-2d0b5d2c":"3005d80b","chunk-2d0b991c":"c2efb425","chunk-2d0baeda":"11073a7b","chunk-2d0bd7bb":"5c65196c","chunk-2d0bd96c":"2554489f","chunk-2d0c033f":"a99acd04","chunk-2d0c211b":"5b030a2f","chunk-2d0c8407":"98206396","chunk-2d0cf315":"d55b4fcd","chunk-2d0cf712":"b4e57c08","chunk-2d0d0b6e":"2ffe5db2","chunk-2d0d39ea":"747eebea","chunk-2d0d6e96":"bb296a0a","chunk-2d0dd10d":"e4689dce","chunk-2d0ddbf2":"4acf4eb6","chunk-2d0e5b90":"2f29f4f5","chunk-2d0e60e5":"e033bc85","chunk-2d0e6486":"a624579c","chunk-2d0e6c36":"d4f15aa8","chunk-2d0e91b5":"66be67da","chunk-2d0e9385":"4f56798c","chunk-2d207d86":"48581bfb","chunk-2d208a0b":"0c87d1c6","chunk-2d20ebc8":"c0462888","chunk-2d216823":"e4299b0a","chunk-2d21731b":"bb7c201c","chunk-2d217def":"1c58d337","chunk-2d21a9aa":"d5bbdfe6","chunk-2d21aad8":"f072f0aa","chunk-2d21da93":"3d847774","chunk-2d21dc41":"1413e8a9","chunk-2d21eace":"e69c7b65","chunk-2d222368":"e286ef73","chunk-2d222cca":"79c1b717","chunk-2d222ce8":"204ff7a1","chunk-2d224869":"e237771e","chunk-2d22895d":"87f5459f","chunk-2d22a0ee":"67d5fe3d","chunk-2d22c6cf":"a286b55e","chunk-2d22e153":"a96ac39d","chunk-2d23721e":"f05c53c6","chunk-2d2374d3":"bf73b182","chunk-3311d804":"1457454c","chunk-5c871c3a":"05268caa","chunk-3e78333a":"2918e923","chunk-87f95dd6":"c76820ed","chunk-342c17d4":"89db0278","chunk-3959ad48":"196f81c3","chunk-3aae185a":"bec4c35d","chunk-3ca03b90":"df0e8e32","chunk-442e8a77":"04f6560d","chunk-4ce1d21f":"e73b0719","chunk-4ed61636":"01e855dd","chunk-089a8b3b":"4cc9ce01","chunk-1fd54d42":"6a46b27f","chunk-3663ab02":"75cf0ec4","chunk-1be1a18f":"f98afe48","chunk-5d176eec":"451d713f","chunk-617cbd6c":"9eb18f82","chunk-9fbaff0a":"6f3d4f55","chunk-8c391ff6":"1ad17af6","chunk-fd5a38da":"9109fe3d","chunk-6463e7e2":"6576b78a","chunk-669015d6":"ab93596b","chunk-6a633537":"9ce11dab","chunk-6db87d5c":"e552610a","chunk-72b5f2d5":"6da0aeb2","chunk-7470ed43":"bff28239","chunk-770b607e":"4d81b46c","chunk-98b1d2f4":"31fed60d","chunk-79ff73ce":"d193e8cb","chunk-c7169596":"c09a4f5a","chunk-cafcd52e":"703689c4","chunk-e0a42872":"28dd73dd","chunk-f56a1410":"c6d8e0d6","stencil-polyfills-css-shim":"4df8bec4","stencil-polyfills-dom":"c17d705d","chunk-2d0a4885":"d5a52777","chunk-2d0f0050":"c14e9794","chunk-2d216786":"fb89e11e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-09764ebc":1,"chunk-0b3b1f24":1,"chunk-204db84c":1,"chunk-8f05731e":1,"chunk-f7bef87a":1,"chunk-2e40015c":1,"chunk-aa53906a":1,"chunk-540f1b15":1,"chunk-05d1e21f":1,"chunk-6eb2e206":1,"chunk-27fe0cec":1,"chunk-513ece05":1,"chunk-728769ff":1,"chunk-20b6fa76":1,"chunk-a0b7269c":1,"chunk-0e4885da":1,"chunk-18694b29":1,"chunk-276956d6":1,"chunk-fbe6f382":1,"chunk-032dd8e3":1,"chunk-7104e44b":1,"chunk-07e25c8c":1,"chunk-644c32b6":1,"chunk-d58206c6":1,"chunk-6ac93044":1,"chunk-76751786":1,"chunk-bcdaca1a":1,"chunk-ef04401a":1,"chunk-c300fdae":1,"chunk-849c1726":1,"chunk-0318066b":1,"chunk-0949322a":1,"chunk-cfc1f3be":1,"chunk-dcdb2db4":1,"chunk-0c8f709c":1,"chunk-25e6c56f":1,"chunk-ee2269fe":1,"chunk-0cffc490":1,"chunk-10ab300e":1,"chunk-13966a58":1,"chunk-18a6dbbc":1,"chunk-1e7c1501":1,"chunk-22aeb9fe":1,"chunk-3311d804":1,"chunk-5c871c3a":1,"chunk-3e78333a":1,"chunk-87f95dd6":1,"chunk-342c17d4":1,"chunk-3959ad48":1,"chunk-3aae185a":1,"chunk-3ca03b90":1,"chunk-442e8a77":1,"chunk-4ce1d21f":1,"chunk-4ed61636":1,"chunk-089a8b3b":1,"chunk-1fd54d42":1,"chunk-3663ab02":1,"chunk-1be1a18f":1,"chunk-5d176eec":1,"chunk-617cbd6c":1,"chunk-9fbaff0a":1,"chunk-8c391ff6":1,"chunk-fd5a38da":1,"chunk-6463e7e2":1,"chunk-669015d6":1,"chunk-6a633537":1,"chunk-6db87d5c":1,"chunk-72b5f2d5":1,"chunk-7470ed43":1,"chunk-98b1d2f4":1,"chunk-79ff73ce":1,"chunk-c7169596":1,"chunk-cafcd52e":1,"chunk-e0a42872":1,"chunk-f56a1410":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-09764ebc":"fc6275ac","chunk-0b3b1f24":"572a2b01","chunk-0c583984":"31d6cfe0","chunk-4a5f46a6":"31d6cfe0","chunk-204db84c":"c76a60a3","chunk-8f05731e":"cf4eff81","chunk-f7bef87a":"06e3cdc4","chunk-34294a1e":"31d6cfe0","chunk-2e40015c":"c8631ef2","chunk-aa53906a":"d38f8a26","chunk-540f1b15":"62b71fde","chunk-05d1e21f":"fae3dd4f","chunk-6eb2e206":"ff36b24c","chunk-27fe0cec":"20497804","chunk-513ece05":"9c2f186d","chunk-728769ff":"9ee29374","chunk-20b6fa76":"9625fe84","chunk-a0b7269c":"a7d9554e","chunk-0e4885da":"a7adaeb8","chunk-18694b29":"2ceaa0d5","chunk-276956d6":"a7adaeb8","chunk-fbe6f382":"baff1afb","chunk-032dd8e3":"f04ea4f9","chunk-7104e44b":"aa9d05cb","chunk-07e25c8c":"6c651b2c","chunk-644c32b6":"7bffd0cb","chunk-d58206c6":"6c651b2c","chunk-6ac93044":"557a44d6","chunk-76751786":"557a44d6","chunk-bcdaca1a":"557a44d6","chunk-ef04401a":"0671109d","chunk-c300fdae":"d3fa8b88","chunk-849c1726":"bf93fbca","chunk-0318066b":"f8858345","chunk-0949322a":"f8858345","chunk-cfc1f3be":"57ec1f0f","chunk-2d0bac5f":"31d6cfe0","chunk-2d0c11d7":"31d6cfe0","chunk-dcdb2db4":"ca2443f3","chunk-0c8f709c":"b0c9e4be","chunk-25e6c56f":"d8707cde","chunk-ee2269fe":"d701c862","chunk-0cffc490":"84fa8191","chunk-10ab300e":"f4b20fd9","chunk-13966a58":"2438e8bc","chunk-18a6dbbc":"4c1fc0bc","chunk-1e7c1501":"fc6275ac","chunk-22aeb9fe":"d0d5eb4b","chunk-2d0a3981":"31d6cfe0","chunk-2d0a463c":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0ac942":"31d6cfe0","chunk-2d0b2b2b":"31d6cfe0","chunk-2d0b5d2c":"31d6cfe0","chunk-2d0b991c":"31d6cfe0","chunk-2d0baeda":"31d6cfe0","chunk-2d0bd7bb":"31d6cfe0","chunk-2d0bd96c":"31d6cfe0","chunk-2d0c033f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c8407":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0cf712":"31d6cfe0","chunk-2d0d0b6e":"31d6cfe0","chunk-2d0d39ea":"31d6cfe0","chunk-2d0d6e96":"31d6cfe0","chunk-2d0dd10d":"31d6cfe0","chunk-2d0ddbf2":"31d6cfe0","chunk-2d0e5b90":"31d6cfe0","chunk-2d0e60e5":"31d6cfe0","chunk-2d0e6486":"31d6cfe0","chunk-2d0e6c36":"31d6cfe0","chunk-2d0e91b5":"31d6cfe0","chunk-2d0e9385":"31d6cfe0","chunk-2d207d86":"31d6cfe0","chunk-2d208a0b":"31d6cfe0","chunk-2d20ebc8":"31d6cfe0","chunk-2d216823":"31d6cfe0","chunk-2d21731b":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21aad8":"31d6cfe0","chunk-2d21da93":"31d6cfe0","chunk-2d21dc41":"31d6cfe0","chunk-2d21eace":"31d6cfe0","chunk-2d222368":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d222ce8":"31d6cfe0","chunk-2d224869":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d22a0ee":"31d6cfe0","chunk-2d22c6cf":"31d6cfe0","chunk-2d22e153":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d2374d3":"31d6cfe0","chunk-3311d804":"8a008836","chunk-5c871c3a":"e57bbd45","chunk-3e78333a":"6787f9d8","chunk-87f95dd6":"7a7e5890","chunk-342c17d4":"6dea1384","chunk-3959ad48":"9dace8ff","chunk-3aae185a":"ffc9a03e","chunk-3ca03b90":"c9ae7dfc","chunk-442e8a77":"03c99333","chunk-4ce1d21f":"752aed4c","chunk-4ed61636":"c6844b0c","chunk-089a8b3b":"1a3440f3","chunk-1fd54d42":"b9036e0a","chunk-3663ab02":"c6bacb4b","chunk-1be1a18f":"8fa78cb6","chunk-5d176eec":"69d3914a","chunk-617cbd6c":"7428f6c5","chunk-9fbaff0a":"495f7af3","chunk-8c391ff6":"c6809ea7","chunk-fd5a38da":"b317b021","chunk-6463e7e2":"9af26c40","chunk-669015d6":"a6468606","chunk-6a633537":"ef6a671e","chunk-6db87d5c":"0f1efc22","chunk-72b5f2d5":"8a008836","chunk-7470ed43":"42b4c36f","chunk-770b607e":"31d6cfe0","chunk-98b1d2f4":"885c1b68","chunk-79ff73ce":"7699ba3f","chunk-c7169596":"026adce9","chunk-cafcd52e":"3cf96152","chunk-e0a42872":"3cf96152","chunk-f56a1410":"fca129b6","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0a4885":"31d6cfe0","chunk-2d0f0050":"31d6cfe0","chunk-2d216786":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
